import axios from 'axios';
import AppConfig from "../../../../../AppConfig";

let URL = AppConfig.HOST_API()+'ekipaKier/';

export default {

    getEkipaKier() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getKierWEkipie(id) {
        return axios({
            method: 'get',
            url: URL + 'ekipa/' + id,
        });
    },

    addEkipaKier(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editEkipaKier(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteEkipaKier(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

    dodajParuKierowcowDoEkipy(ekipa_id,lista_kierowcow){
        return axios(
            {
                url: URL + 'ekipa/'+ekipa_id,
                method: 'put',
                data: JSON.stringify(lista_kierowcow),
            }
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipy/polaczenieEkipy/EkipyKierowcyService.js